import { useContext, useState } from "react";
import SignCanvas from "./SignCanvas";
import { Table } from "reactstrap";
import { formatDate } from "../../../Utils/externalFunctions";
import LocationColumn from "../constants/LocationColumn";
import SignForm from "./ModalYangMenyerahkan";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const SignTable = ({ datatable, type, resetState, status=null }) => {
  const tandaTerimaAPI = useTandaTerima();
  const { checkPermission } = useContext(RoleContext);
  const [selectedSignId, setSelectedSignId] = useState(null);
  const [isCanvasOpen, setIsCanvasOpen] = useState(false);

  const handleSign = (id) => {
    setSelectedSignId(id);
    setIsCanvasOpen(true);
  };

  const handleSaveSignature = async (signatureData, latitude, longitude) => {
    try {
      const payload = {
        sign: signatureData,
        latitude,
        longitude,
      };

      const updateMethods = {
        penerima: tandaTerimaAPI.updatePenerimaSign,
        pemberi_tugas: tandaTerimaAPI.updatePemberiTugasSign,
        yang_menyerahkan: tandaTerimaAPI.updateYangMenyerahkanSign,
      };

      await updateMethods[type](selectedSignId, payload);
      resetState?.();
      setIsCanvasOpen(false);
      setSelectedSignId(null);
    } catch (error) {
      console.error("Error saving signature:", error);
    }
  };

  const checkKurir = () => {
    try {
      const storedKurir = localStorage.getItem("selectedKurir");
      if (!storedKurir) {
        console.error("No selectedKurir found in localStorage");
        return false;
      }
      
      const parsed = JSON.parse(storedKurir);
      if (!parsed || !parsed.nama) {
        console.error("Invalid selectedKurir data:", parsed);
        return false;
      }
      
      return true;
    } catch (error) {
      console.error("Error in checkStatus:", error);
      return false;
    }
  }
  
  const checkStatus = () => {
    const storedKurir = localStorage.getItem("selectedKurir");
    const parsed = JSON.parse(storedKurir);
    const result = status === `Diantarkan oleh ${parsed.nama}`;
    return result
  }

  const renderSignButton = (item) => {
    if (item.sign) {
      return (
        <img
          src={item.sign}
          alt="signature"
          className="h-12"
          style={{ width: "100px", height: "50px" }}
        />
      );
    }
  
    const isKurir = checkKurir();
    
    if (isKurir) {
      if (type === "pemberi_tugas") {
        return (
          <img
            src={item.sign}
            alt="signature"
            className="h-12"
            style={{ width: "100px", height: "50px" }}
          />
        );
      }
      
      if (type === "yang_menyerahkan" && checkPermission(PERMISSIONS.ADD_TANDA_TANGAN_YANG_MENYERAHKAN)) {
        return (
          <button
            className="btn btn-link"
            onClick={() => handleSign(item.id)}
            style={{ width: "200px" }}
          >
            Sign Here
          </button>
        );
      }
      
      if (type === "penerima" && status && checkStatus() && 
          checkPermission(PERMISSIONS.ADD_TANDA_TANGAN_PENERIMA)) {
        return (
          <SignForm
            idTandaTerima={item.id}
            resetState={resetState}
            type="penerima"
          />
        );
      }
    } 
    else {
      if (type === "penerima") {
        return (
          <SignForm
            idTandaTerima={item.id}
            resetState={resetState}
            type="penerima"
          />
        );
      }
      
      if (checkPermission(PERMISSIONS.ADD_TANDA_TANGAN_PEMBERI_TUGAS)) {
        return (
          <button
            className="btn btn-link"
            onClick={() => handleSign(item.id)}
            style={{ width: "200px" }}
          >
            Sign Here
          </button>
        );
      }
    }
    
    return <div>&nbsp;</div>;
  };


  return (
    <div className="w-full">
      <Table className="w-full border-collapse border">
        <thead>
          <tr>
            <th style={{ border: "1px solid black" }} className="p-2 text-left">
              No.
            </th>
            <th style={{ border: "1px solid black" }} className="p-2 text-left">
              {type === "penerima" ? "Kepada" : "Nama"}
            </th>
            {type === "penerima" && (
              <th
                style={{ border: "1px solid black" }}
                className="p-2 text-left"
              >
                Penerima
              </th>
            )}
            <th style={{ border: "1px solid black" }} className="p-2 text-left">
              Tanda Tangan
            </th>
            <th style={{ border: "1px solid black" }} className="p-2 text-left">
              Waktu
            </th>
            <th style={{ border: "1px solid black" }} className="p-2 text-left">
              Lokasi
            </th>
          </tr>
        </thead>
        <tbody>
          {datatable.map((item, index) => (
            <tr key={item.id}>
              <td
                style={{ border: "1px solid black", width: "20px" }}
                className="p-2"
              >
                {index + 1}
              </td>
              <td
                style={{ border: "1px solid black", width: "200px" }}
                className="p-2"
              >
                {item.kepada ||
                  item.nama_pemberi_tugas ||
                  item.nama_yang_menyerahkan}
              </td>
              {type === "penerima" && (
                <td
                  style={{ border: "1px solid black", width: "200px" }}
                  className="p-2"
                >
                  {item.nama_penerima || "-"}
                </td>
              )}
              <td
                style={{ borderBottom: "1px solid black" }}
                className="p-2 d-flex justify-content-center"
              >
                {renderSignButton(item)}
              </td>
              <td
                style={{ border: "1px solid black", width: "150px" }}
                className="p-2"
              >
                {item.date_signed ? formatDate(item.date_signed) : "-"}
              </td>
              <td
                style={{ border: "1px solid black", width: "200px" }}
                className="p-2"
              >
                <LocationColumn
                  latitude={item.latitude}
                  longitude={item.longitude}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <SignCanvas
        isCanvasOpen={isCanvasOpen}
        setIsCanvasOpen={setIsCanvasOpen}
        onSave={handleSaveSignature}
      />
    </div>
  );
};

export default SignTable;
